import ApiService from './ApiService';

const get = async (id: string, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.get(`/feedbacks/${id}`)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const list = async (successFn: Function) => {
  const { data, status } = await ApiService.get(`/feedbacks`)

  if (status === 200) {
    successFn(data)
  }
}

const listPending = async () => {

  try {
    const { data, status } = await ApiService.get(`/feedbacks/pending_invitations`)

    if (status === 200) {
      return data
    }
  } catch (error) {
    console.error("❌ Erro na requisição listPending:", error);
    throw error;
  }
}

const insertIdCognitoFeedback = async () => {


  try {
    const { data, status } = await ApiService.post(`/users/insert_cognito_id`)

    if (status === 200) {
      return data
    }

    return [];

  } catch (error) {
    console.error("❌ Erro na requisição insertIdCognitoFeedback:", error);
    throw error;
  }
}

const create = async (feedback: IFeedback, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.post(`/feedbacks`, feedback)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const update = async (feedback: IFeedback, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.put(`/feedbacks`, feedback)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const destroy = async (id: string, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.delete(`/feedbacks/${id}`)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const resendEmail = async (id: string, payload: any, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.post(`/feedbacks/${id}/resend_email`, payload)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const acceptInvitation = async (id: string, invitation_code: string, payload: IAcceptInvitationPayload, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.post(`/feedbacks/${id}/accept_invitation/${invitation_code}`, payload)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

const rejectInvitation = async (id: string, invitation_code: string, successFn: Function, errorFn: Function) => {
  const { data, status } = await ApiService.post(`/feedbacks/${id}/reject_invitation/${invitation_code}`)

  if (status === 200) {
    successFn(data)
  } else {
    errorFn(data)
  }
}

export { get, list, create, update, destroy, resendEmail, acceptInvitation, rejectInvitation, listPending, insertIdCognitoFeedback };
